import styled, { keyframes } from 'styled-components'
import { shade } from 'polished'
import { animated } from '@react-spring/web'
import Button from '@shared/components/Button'

import signInBackgrounImage from '@modules/users/assets/banner-login.jpg'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: stretch;
`

export const Transition = styled(animated.div)`
  width: 100%;
  display: flex;
  max-width: 45rem;
  flex-direction: column;
  place-content: center;

  animation: ${keyframes`
    from {
      opacity: 0;
      transform: translateX(-50px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  `} 1s;
`

export const Content = styled.div`
  padding: 1rem;

  img {
    display: block;
    margin: 0 auto;
    max-width: 240px;
  }

  .login-form {
    text-align: center;
    margin: 1.5rem auto;
    width: 20rem;

    &__title {
      font-size: 2rem;
      margin: 1.5rem auto;
      text-align: center;
    }

    &__recover-pass {
      margin-top: 1rem;
      padding: .5rem;
      color: ${props => props.theme.text};
      display: block;
      text-decoration: none;
    }
  }

  .create-account {
      color: ${props => props.theme.primary};
      text-decoration: none;
      padding: .5rem;
      width: 100%;
      transition: color .2s;

      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        margin-right: .5rem;
      }

      &:hover {
        color: ${props => shade(0.2, props.theme.primary)}
      }
  }
`

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 1.5rem auto;

  span {
    margin: 0 1rem;
  }

  hr {
    width: 100%;
    opacity: 0.25;
  }

`

export const SignInWithPaggue = styled(Button)`
  position: relative;
  overflow: hidden;

  margin-top: 1rem;
  background: linear-gradient(90deg, #7C009F 0%, #9600C0 100%);

  padding-left: 3.5rem;

  width: 100%;

  .singin-with-paggue {
    &__logo {
      position: absolute;
      width: auto;
      height: 100%;

      left: 0;
      top: 50%;
      background: #7C009F;
      transform: translateY(-50%);
    }
  }

  &:hover {
    background: linear-gradient(90deg, #7C009F 0%, #9600C0 100%);;
  }
`
export const Background = styled.div`
  flex: 1;
  background: url(${signInBackgrounImage}) no-repeat center;
  background-size: cover;
`
